import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
    display: flex;
    width: ${({ width }) => width || '160px'};
`;

const Option = styled.span`
    flex: 1;
    display: flex;

    &:not(:first-child) {
        label {
            border-left: 0;
        }
    }

    &:first-child {
        label {
            border-radius: 5px 0 0 5px;
        }
    }
    &:last-child {
        label {
            border-radius: 0 5px 5px 0;
        }
    }
    input {
        appearance: none;
        &:checked + label {
            color: ${({ theme }) => theme.primary.bg};
            background: ${({ isTruthy, theme }) =>
                isTruthy ? theme.primary.fg : theme.bodyText};
            border-color: ${({ isTruthy, theme }) =>
                isTruthy ? theme.primary.fg : theme.bodyText};
        }
    }
    label {
        margin: 0;
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        border: 1px solid ${({ theme }) => theme.inputBorder};
    }
`;

/**
 * @typedef {Object} Props
 * @property {string} [name]
 * @property {string} [width]
 * @property {string} onLabel
 * @property {string} offLabel
 * @property {Function} [onChange]
 * @property {string|boolean} onValue
 * @property {string|boolean} offValue
 * @property {string|boolean} [defaultValue]
 *
 * @param {Props} param0
 */
const Switch = ({
    name,
    width,
    onLabel,
    onValue,
    offLabel,
    offValue,
    onChange,
    defaultValue,
    ...restOfProps
}) => {
    const { value = defaultValue } = restOfProps;

    const handleChange = value => {
        if (value === 'true') {
            value = true;
        } else if (value === 'false') {
            value = false;
        }
        onChange({ value, name });
    };

    return (
        <Wrap width={width}>
            <Option>
                <input
                    type="radio"
                    id={name + '_off'}
                    name={name}
                    value={offValue || false}
                    checked={value === offValue}
                    onChange={e => handleChange(e.target.value)}
                />
                <label htmlFor={name + '_off'}>{offLabel}</label>
            </Option>
            <Option isTruthy>
                <input
                    type="radio"
                    id={name + '_on'}
                    name={name}
                    value={onValue || true}
                    checked={value === onValue}
                    onChange={e => handleChange(e.target.value)}
                />
                <label htmlFor={name + '_on'}>{onLabel}</label>
            </Option>
        </Wrap>
    );
};

export default Switch;
